import { Inject, Injectable } from '@angular/core';
import { DataService } from '../../../core/service/base/data.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { DwellingInspectionType } from '../../model/dwelling-inspection-type';

@Injectable()
export class DwellingInspectionTypeService extends DataService<DwellingInspectionType> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, DwellingInspectionType, progressBar, 'dwelling-inspection-type');
  }
}
